/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespContentModuleRegular_browseContentModule$ref = any;
type SbSharedContentModuleBanner_browseContentModule$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespContentModuleSelector_searchBrowse$ref: FragmentReference;
export type SbRespContentModuleSelector_searchBrowse = {|
  +browseContentModule: ?{|
    +moduleType: ?string,
    +$fragmentRefs: SbRespContentModuleRegular_browseContentModule$ref & SbSharedContentModuleBanner_browseContentModule$ref,
  |},
  +$refType: SbRespContentModuleSelector_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespContentModuleSelector_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "contentModuleId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "browseContentModule",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "contentModuleId",
          "variableName": "contentModuleId",
          "type": "String"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "moduleType",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbRespContentModuleRegular_browseContentModule",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "SbSharedContentModuleBanner_browseContentModule",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '165793a5d6780b34be43c5ab621d6298';
module.exports = node;
